import { render, staticRenderFns } from "./DashboardUserDefault.vue?vue&type=template&id=1016abcc&lang=pug"
import script from "./DashboardUserDefault.vue?vue&type=script&lang=js"
export * from "./DashboardUserDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports